import { message } from 'antd';
import { getAllSetInsurances } from 'api/insurance';
import { getProviderInsurancesListByProviderId } from 'api/operation/Insurance';
import { useCallback, useEffect, useState } from 'react';
import { IInsurance } from 'types/insurance';

const useGetProviderAllInsurance = (providerId?: number, isOps?: boolean):[IInsurance[] | undefined, boolean, string] => {
    const [data, setData] = useState<IInsurance[]>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            let res;
            if (isOps) {
                if (providerId) {
                    res = await getProviderInsurancesListByProviderId(providerId);
                } else {
                    const errorMsg = 'Provider ID is required';
                    setError(errorMsg);
                    message.error(errorMsg);
                }
            } else {
                res = await getAllSetInsurances();
            }
            setLoading(false);

            if (res && res.error) {
                setError(res.error);
                message.error(res.error);
            } else {
                setData(res?.data?.data);
            }
        } catch (e) {
            setLoading(false);
            console.error(e);
        }
    }, [isOps, providerId]);
    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, error];
};

export default useGetProviderAllInsurance;
